export default __webpack_public_path__ + "static/media/gallery-arrow-l.55a49afb.svg";